import { Outlet } from "react-router";
import MaintenancePage from "modules/Internal/pages/Maintenance.page";
import { PageLoading } from "shared/components/utils/PageLoading";
import { useOpenFeatureFlag } from "shared/hooks";

// Pages without the app navbar; authenticated onboarding still has UserProvider above it.
export const PublicLayout = () => {
  const { loading, value: maintenanceEnabled } = useOpenFeatureFlag("maintenance_screen_enabled");

  if (loading) return <PageLoading />;
  if (maintenanceEnabled) return <MaintenancePage />;

  return <Outlet />;
};
